import envConst from './env-const.js'
const setTheme = function(themeName) {
  let style = document.createElement('link')
  style.id = 'theme-style'
  style.rel = 'stylesheet'
  style.type = 'text/css'
  if (process.env.VUE_APP_IS_MODULE) {
    style.href = `${envConst.SCMCC_HOST}/theme/${themeName}.css`
  } else {
    style.href = `./theme/${themeName}.css`
  }
  document.head.appendChild(style)
}
const setIconfont = function(){
  let script = document.createElement('script')
  if (process.env.VUE_APP_IS_MODULE) {
    script.src = `${envConst.SCMCC_HOST}/iconfont.js`
  } else {
    script.src = `./iconfont.js`
  }
  document.body.appendChild(script)
}
export default function(store) {
  setTheme(store.state.main.user.theme)
  setIconfont()
}
